module.exports = __webpack_public_path__ + "img/shield-o.ee35b98e.svg";